<template>
  <div class="sub-tabs" :class="bem('sub-tabs', { appearance })">
    <div class="sub-tabs__tabs">
      <div
        v-for="tab in tabs"
        class="sub-tabs__tab"
      >
        <SubTab :tab="tab" :appearance="appearance" />
      </div>
    </div>
  </div>
</template>

<script>
  import SubTab from 'src/components/tabs/SubTab/SubTab.vue';
  import { bem } from 'src/utils/bem.js';

  export default {
    name: 'SubTabs',
    components: { SubTab },
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      appearance: String,
    },
    methods: {
      bem,
    }
  }
</script>